var dropdownSearchInputStyles = {
    input: function (_a) {
        var backgroundColor = _a.variables.backgroundColor;
        return ({
            width: '100%',
            backgroundColor: backgroundColor,
            ':focus': {
                borderBottomColor: 'transparent',
            },
        });
    },
    wrapper: function (_a) {
        var editTextFlexBasis = _a.variables.editTextFlexBasis;
        return ({
            flexBasis: editTextFlexBasis,
            flexGrow: 1,
        });
    },
};
export default dropdownSearchInputStyles;
